import React, {useEffect, useState} from "react";

import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";
import {useAuth} from "../components/Authentication/AuthProvider";
import CardError from "../components/Cards/CardError";


export default function Error404() {
    const auth = useAuth();

    document.title = "Oops";


    return (
        <>
            <section>
                <AuthNavbar userdata={auth.user}/>
            </section>


            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">


                    <h2 className="text-36 text-yellow">Sorry...</h2>
                    <p className="text-20-30 text-white">
                        Something went wrong.
                    </p>

                    <CardError message={'These are uncharted waters.'}/>
                </div>

            </section>


        </>
    );
}